// extracted by mini-css-extract-plugin
export default {"modalContainer":"ErrorModal_modalContainer__tTPaN","modal":"ErrorModal_modal__lXRCk","titleContainer":"ErrorModal_titleContainer__nKd8T"};